/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){



  
  // Quick Shop - Collection View
  // $('.quick-shop').on('click', function(e) {
  //   var modal, button, block, id, product, link;

  //   modal = $('#product-detail-modal');

  //   button = $(this);
  //   block = button.closest('.ProductItem');
  //   link = block.find('.product-link').eq(0);

  //   id = block.data('product-id');
  //   product = getProductJSON(id);

  //   if (modal.hasClass('visible')) {
  //     $('body').removeClass('no-scroll');
  //     modal.removeClass('visible');
  //   } else {
  //     $('body').addClass('no-scroll');
  //     modal.find('.inner').html('');
  //     modal.addClass('visible');

  //     $.get(link.attr('href'), function(response) {
  //       var html = $('#main-product-detail', $(response));

  //       modal.find('.inner').html(html);
  //       modal.find('.slideshow').each(initializeSlideshow);
  //       modal.find('.product-form').each(updateOptionButtonUI);
  //       modal.find('select[name="id"]').trigger('optionate');

		// 		// Ensure Slick slider updates slide height
		// 		modal.find('img').imagesLoaded(function(){
		// 			$(window).trigger('resize');
		// 		});

  //       //yotpo.initWidgets();
  //     });
  //   }

  //   e.preventDefault();
  // });

  // // Close product modal
  // $(document).on('click', '.product-modal .close-detail', function(e) {
  //   $('body').removeClass('no-scroll');
  //   $(this).closest('.product-modal').removeClass('visible');
  //   e.preventDefault();
  // });



});

// document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", variant.price);
// window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
// window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })